function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortDescDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.00004 7.33333H14C14.1769 7.33333 14.3464 7.2631 14.4714 7.13807C14.5965 7.01305 14.6667 6.84348 14.6667 6.66667C14.6667 6.48986 14.5965 6.32029 14.4714 6.19526C14.3464 6.07024 14.1769 6 14 6H2.00004C1.82323 6 1.65366 6.07024 1.52864 6.19526C1.40361 6.32029 1.33337 6.48986 1.33337 6.66667C1.33337 6.84348 1.40361 7.01305 1.52864 7.13807C1.65366 7.2631 1.82323 7.33333 2.00004 7.33333ZM14 8.66667H2.00004C1.82323 8.66667 1.65366 8.7369 1.52864 8.86193C1.40361 8.98695 1.33337 9.15652 1.33337 9.33333C1.33337 9.51014 1.40361 9.67971 1.52864 9.80474C1.65366 9.92976 1.82323 10 2.00004 10H14C14.1769 10 14.3464 9.92976 14.4714 9.80474C14.5965 9.67971 14.6667 9.51014 14.6667 9.33333C14.6667 9.15652 14.5965 8.98695 14.4714 8.86193C14.3464 8.7369 14.1769 8.66667 14 8.66667Z",
    fill: "#2C303B",
    style: {
      fill: "#2C303B",
      fill: "color(display-p3 0.1725 0.1882 0.2314)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortDescDark);
export default __webpack_public_path__ + "static/media/short-desc-dark.57c3a52f0c416486f181677627ee1ef6.svg";
export { ForwardRef as ReactComponent };